import FullCalendar from "@fullcalendar/react";
import daygridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import React, {useEffect, useState} from "react";
import {FormattedMessage, injectIntl} from 'react-intl'
import {Dispatch, bindActionCreators} from 'redux';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import * as actions from '../../actions/generalActions';
import * as clientActions from '../../actions/client';
import * as agreementActions from '../../actions/agreements';
import * as offerActions from '../../actions/offers';
import {RootState} from '../../reducers';
import moment from "moment";
import {SelectOption} from "../../types/selectOption.type";
import DifferentColoredPlus from "../../assets/icons/differentColoredPlus.svg";
import HotkeyButton from "../../components/HotkeyButton/HotkeyButton";
import {setLoading} from "../../actions/generalActions";
import SimpleLoader from "../../components/Spinner/SimpleLoader";
import DataTransferComponent from "../../components/DataTransferComponent/DataTransferComponent";
import {EInputTextType, Input} from "../../components/Input/Input";
import {Button, EButtonType} from "../../components/Button";
import {toast} from "react-toastify";
import TaskForm from "./Tasks/TaskForm";
import {getMonthsBetween} from "../Admin/globalFunctions";
import {editAgreementDates} from "../../actions/agreements";
import {axiosCaller} from "../../utils/apiCaller";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './Agreements.scss';

interface Props {
    loading: boolean
    actions: any,
    calendarData: any[],
    calendarDataPerClient: any[],
    client: any,
    clientActions: any,
    agreements: any
    offers: any
    intl: any
    buttonLoader: boolean
    departments: any
    projectDetails: any
    agreementActions: any
    offerActions: any
    history: any
}

const AgreementCalendar = (props: Props) => {
    const fm = (id: string, defaultMessage: string, values?: Record<string, any>) =>
        props.intl.formatMessage({ id, defaultMessage }, values);

    const [calendarEvents, setCalendarEvents] = useState([])
    const [selectedProduct, setSelectedProduct] = useState<any>()
    const [productIdForModal, setProductIdForModal] = useState<number>()
    const [selectedDepartment, setSelectedDepartment] = useState<SelectOption>({} as SelectOption)
    const [startDate, setStartDate] = useState<any>()
    const [calendarComment, setCalendarComment] = useState('')
    const [initialStartDate, setInitialStartDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()
    const [productData, setProductData] = useState<any>()
    const [loading, setLoading] = useState<boolean>(false)
    const [calendarDateView, setCalendarDateView] = useState(moment().format('YYYY-MM-DD'))
    const currentDate = moment().format('YYYY-MM-DD')
    const [showYearlyProduction, setShowYearlyProduction] = useState<boolean>(false)
    const [showTaskModal, setShowTaskModal] = useState<boolean>(false)
    const [taskCreationModal, setTaskCreationModal] = useState<boolean>(false)
    const [selectedAgreement, setSelectedAgreement] = useState<any>()
    const [selectedTask, setSelectedTask] = useState<any>()
    const [searchQuery, setSearchQuery] = useState('');
    const [startMonth, setStartMonth] = useState<any>()
    const [endMonth, setEndMonth] = useState<any>()
    const [selectedMonths, setSelectedMonths] = useState([])

    // State for offer installation calendar
    const [selectedOffer, setSelectedOffer] = useState<any>(null)
    const [installationDateHistory, setInstallationDateHistory] = useState<any[]>([])
    const [showInstallationHistory, setShowInstallationHistory] = useState<boolean>(false)
    const [newInstallationDate, setNewInstallationDate] = useState<Date | null>(null)
    const [installationDateComment, setInstallationDateComment] = useState<string>('')
    const [savingDate, setSavingDate] = useState<boolean>(false)


    useEffect(() => {
        // Fetch offers for installation calendar instead of agreements
        props.offerActions.getOffersForInstallationCalendar()
        // Comment out old logic:
        // props.agreementActions.getAgreementsForCalendar()
    }, [])

    useEffect(() => {
        let calendarEventArray = []

        // Tasks (keep this logic)
        props.agreements?.tasks?.forEach((task) => {
            calendarEventArray.push({
                ...task,
                taskId: task?.id,
                start: task?.start,
                end: task?.end,
            })
        })

        // New: Use offers for installation calendar instead of agreements
        props.offers?.offersForInstallationCalendar?.forEach((offer: any) => {
            // Convert installation date from dd/mm/yyyy to yyyy-mm-dd for calendar
            let installationDateForCalendar = ''
            if (offer?.installationDate) {
                const parts = offer.installationDate.split('/')
                if (parts.length === 3) {
                    installationDateForCalendar = `${parts[2]}-${parts[1]}-${parts[0]}`
                }
            }

            calendarEventArray.push({
                ...offer,
                id: offer?.id,
                clientName: offer?.clientName,
                projectName: offer?.projectName,
                start: installationDateForCalendar,
                end: installationDateForCalendar,
                isOffer: true // Flag to differentiate from tasks
            })
        })

        // Comment out old agreements logic:
        // props.agreements?.agreementsForCalendar?.forEach((calendarEvent) => {
        //     let endingDate = calendarEvent?.end
        //     if(!calendarEvent?.end){
        //         endingDate = moment(calendarEvent?.start).add(1, 'day').format("YYYY-MM-DD")
        //     }
        //     calendarEventArray.push({
        //         ...calendarEvent,
        //         clientName: calendarEvent?.client?.name,
        //         projectName: calendarEvent?.project?.name,
        //         id: calendarEvent?.id,
        //         start: calendarEvent?.start,
        //         end: endingDate,
        //     })
        // })

        calendarEventArray.sort(function compare(a, b) {
            let firstMilliseconds = new Date(a['end']).getTime();
            let secondMilliseconds = new Date(b['end']).getTime();
            return firstMilliseconds - secondMilliseconds;
        });
        console.log(calendarEventArray,'calendarEventArray SORTED')
        setCalendarEvents(calendarEventArray)
    }, [props.offers?.offersForInstallationCalendar, props.agreements?.tasks])


    function addDays(date, days) {
        let result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;

    }

    function searchClick(searchItem) {
        if (searchItem?.taskId) {
            selectTask(searchItem)
        } else {
            setModalData({id: searchItem?.id, extendedProps: {...searchItem}})
        }
    }

    function setModalData(event) {
        const eventData = event?.extendedProps || event

        // Check if this is an offer (installation calendar)
        if (eventData?.isOffer) {
            setSelectedOffer({
                ...eventData,
                id: event?.id
            })

            // Convert installation date from dd/mm/yyyy to Date object for DatePicker
            if (eventData?.installationDate) {
                const parts = eventData.installationDate.split('/')
                if (parts.length === 3) {
                    // parts[0] = day, parts[1] = month, parts[2] = year
                    const dateObj = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
                    setNewInstallationDate(dateObj)
                }
            } else {
                setNewInstallationDate(null)
            }

            // Fetch installation date history
            axiosCaller('GET', `offers/${event?.id}/installation-history`).then((res) => {
                setInstallationDateHistory(res.data.data || [])
            }).catch((err) => {
                console.error('Error fetching installation history:', err)
            })
            return
        }

        // Old agreement logic (commented out but kept for reference)
        console.log(event,'agreement,')
        return
        // make call
        let endingDate = event?.end

        setLoading(true)
        if(!event?.end){
            endingDate = moment(event?.start).add(1, 'day').format("YYYY-MM-DD")
        }
        setStartDate(new Date(moment(event?.start).format("YYYY-MM-DD")))
        setEndDate(new Date(endingDate))

        setSelectedAgreement({
            ...event.extendedProps,
            id: event?.id
        })
        props.actions.getAllProjectInfo('', event?.extendedProps?.project?.id).then(() => {
            setLoading(false)
        })
    }

    function closeOfferModal() {
        setSelectedOffer(null)
        setInstallationDateHistory([])
        setShowInstallationHistory(false)
        setNewInstallationDate(null)
        setInstallationDateComment('')
    }

    function saveInstallationDate() {
        if (!newInstallationDate) {
            toast.error(fm('agreement.calendar.toast.selectInstallationDate', 'Please select the installation date!'))
            return
        }

        if (!installationDateComment) {
            toast.error(fm('agreement.calendar.toast.commentRequiredForDateChange', 'A comment is required when changing the installation date!'))
            return
        }

        // Validate date is not in the past
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const selectedDate = new Date(newInstallationDate)
        selectedDate.setHours(0, 0, 0, 0)

        if (selectedDate < today) {
            toast.error(fm('agreement.calendar.toast.dateCannotBeInPast', 'The installation date cannot be in the past!'))
            return
        }

        setSavingDate(true)

        // Convert Date object to dd/mm/yyyy format
        const formattedDate = moment(newInstallationDate).format('DD/MM/YYYY')

        const payload = {
            offerId: selectedOffer?.id,
            installationDate: formattedDate,
            comment: installationDateComment
        }

        axiosCaller('POST', 'offers/update-installation-date', payload).then((res) => {
            toast.info(fm('agreement.calendar.toast.installationDateChanged', 'Installation date changed successfully!'))
            // Refresh calendar data
            props.offerActions.getOffersForInstallationCalendar()
            closeOfferModal()
            setSavingDate(false)
        }).catch((err) => {
            if (err.response?.data?.message) {
                toast.error(err.response.data.message)
            } else {
                toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'))
            }
            setSavingDate(false)
        })
    }

    function navigateToOffer() {
        if (selectedOffer?.id && selectedOffer?.projectId) {
            // Store the navigation data before closing modal
            const offerId = selectedOffer.id
            const projectId = selectedOffer.projectId
            // Close the modal first to avoid state issues
            closeOfferModal()
            // Navigate after a small delay to ensure modal is closed
            setTimeout(() => {
                props.history.push(`/dashboard/offers/create/${offerId}/${projectId}`)
            }, 100)
        } else {
            toast.error(fm('agreement.calendar.toast.cannotOpenOffer', 'Cannot open the offer — data is missing!'))
        }
    }

    function selectTask(calendarTaskEvent) {
        setShowTaskModal(true)
        setSelectedTask(calendarTaskEvent)
        console.log(calendarTaskEvent, 'calendarTaskEvent')
    }


    function renderEventContent(eventInfo) {
        if (eventInfo?.event?.extendedProps?.taskId) {
            return (
                <div className={`event-container eventNr${eventInfo?.event?.id}`}
                     onClick={() => selectTask(eventInfo?.event)}>
                    <p>{eventInfo?.event?.title} ({eventInfo?.event?.extendedProps?.user?.name})</p>
                    <p>{eventInfo?.event?.extendedProps?.comment}</p>
                </div>
            )
        } else if (eventInfo?.event?.extendedProps?.isOffer) {
            // Render offer installation event
            return (
                <div className={`event-container offer-event eventNr${eventInfo?.event?.id}`}
                     onClick={() => setModalData(eventInfo?.event)}
                     style={{backgroundColor: '#4CAF50', color: 'white', padding: '2px 4px', borderRadius: '3px'}}>
                    <p style={{margin: 0, fontSize: '11px'}}>{eventInfo?.event?.extendedProps?.clientName}</p>
                    <p style={{margin: 0, fontSize: '10px'}}>{eventInfo?.event?.extendedProps?.projectName}</p>
                </div>
            )
        } else {
            return (
                <div className={`${eventInfo?.event?.extendedProps?.project?.shipmentDestinationId == 2 ? "export" : ""} event-container eventNr${eventInfo?.event?.id}`}
                     onClick={() => setModalData(eventInfo?.event)}>
                    <p>{eventInfo?.event?.extendedProps?.client?.name} ({moment(eventInfo?.event?.end)?.format('DD-MM-YYYY')})</p>
                    <p>{eventInfo?.event?.extendedProps?.project?.name}({eventInfo?.event?.extendedProps?.project?.shipmentDestinationName})</p>
                </div>
            )
        }
    }


    function closeAgreementInfoModal() {
        setSelectedAgreement({})
    }

    function selectCalendarView(monthView) {
        setCalendarDateView(monthView)
        setShowYearlyProduction(false)
    }

    function saveStartAndEndDate() {
        // if(moment(updatedStartDate) < moment()){
        //     toast.error('Data e fillimit nuk duhet te jete ne te kaluaren!')
        //     return;
        // }
        //
        // if(moment(updatedEndDate) < moment(updatedStartDate)){
        //     toast.error('Data e mbarimit nuk duhet te jete para se te filloi!')
        //     return;
        // }
        //
        // if (!updatedStartDate) {
        //     toast.error('Ju lutem mbushni daten e fillimit')
        //     return
        // }
        //
        // let payload = {
        //     productId: Number(updateDatesPayload?.productId),
        //     start: updatedStartDate ? moment(updatedStartDate).format('YYYY-MM-DD') : '',
        //     end: updatedEndDate ? moment(updatedEndDate).format('YYYY-MM-DD') : ''
        // }
        //
        // props.productionActions.updateProductDates(payload).then((res)=>{
        //     if (res.data) {
        //         toast.success('Datat u ndryshuan me sukses!')
        //         setUpdateDatesPayload({
        //             startDate: '',
        //             endDate: '',
        //             articleId: '',
        //             productId: '',
        //             quantity: ''
        //         })
        //         props?.getProductsOfClient()
        //     } else {
        //         toast.error('Diqka shkoi gabim!')
        //     }
        // })
    }

    const filteredData = calendarEvents.filter(item =>
        Object.values(item).some(value =>
            typeof value === 'string' && value.toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const objectWithMonths = {
        "January": "01",
        "February": "02",
        "March": "03",
        "April": "04",
        "May": "05",
        "June": "06",
        "July": "07",
        "August": "08",
        "September": "09",
        "October": "10",
        "November": "11",
        "December": "12"
    };

    function filterMonths(){
        let arrayOfMonths = getMonthsBetween(startMonth, endMonth)
        let arrayOfMonthsForCalendar = []
        arrayOfMonths?.forEach((month)=>{
            console.log(currentDate, month.split(' '))
            arrayOfMonthsForCalendar.push({
                label: month?.split(' ')[0],
                value: `${month?.split(' ')[1]}-${objectWithMonths[month?.split(' ')[0]]}-01`
            })
        })
        setShowYearlyProduction(true)
        setSelectedMonths(arrayOfMonthsForCalendar)
    }

    function saveAgreementDates(){
        let payload = new FormData();

        payload.append("agreementId", selectedAgreement?.id);

        if(startDate){
            payload.append("start", moment(startDate).format('YYYY-MM-DD'));
        }
        if(endDate){
            payload.append("end", moment(endDate).format('YYYY-MM-DD'));
        }
        console.log(payload, props?.agreementActions)
        props.agreementActions?.editAgreementDates(payload).then(() => {
            props.agreementActions.getAgreementsForCalendar()
            closeAgreementInfoModal()
            toast.info(fm('agreement.calendar.toast.datesEdited', 'Dates updated successfully!'))
        })

    }

    return (
        <div className="agreements-calendar-container">
            <div className={`showYearlyProductionButtonAgreement ${showYearlyProduction ? "show": "hide"}`}>
                <input type="month" value={startMonth} onChange={(event)=> setStartMonth(event.target?.value)}/>
                <input type="month" value={endMonth} onChange={(event)=>setEndMonth(event.target?.value)} />
                <button onClick={filterMonths} className={'filterMonths'}>{fm('agreement.calendar.filterMonths', 'Filter')}</button>
            </div>
            <div className={'addTaskButton'} onClick={() => setShowTaskModal(true)}>
                <p>
                    <FormattedMessage id="agreement.calendar.addTask" defaultMessage="Add task"/>
                </p>
            </div>
            <div className={'searchFilter'}>
                <div className={'inputAndListContainer'}>
                    <Input
                        name="searchQuery"
                        value={searchQuery || ''}
                        type="text"
                        inputWrapperClass="col-12 m-0"
                        onChange={(name, value) => setSearchQuery(value)}
                        inputTextType={EInputTextType.SimpleInput}
                        placeholder={fm('agreement.calendar.search', 'Search...')}/>
                    {searchQuery && <div className={'searchList'}>
                        {searchQuery && filteredData.map(item => (
                            <>
                                {item?.taskId ?
                                    <div className={"itemContainer"} onClick={() => searchClick(item)} key={item?.id}>
                                        <p><FormattedMessage id="agreement.calendar.searchTitle" defaultMessage="Title:" /> {item.title}</p>
                                        <p><FormattedMessage id="agreement.calendar.searchComment" defaultMessage="Comment:" /> {item.comment}</p>
                                    </div>
                                    :
                                    <div className={"itemContainer"} onClick={() => searchClick(item)} key={item?.id}>
                                        <p><FormattedMessage id="agreement.calendar.searchProjectName" defaultMessage="Project name:" /> {item.projectName}</p>
                                        <p><FormattedMessage id="agreement.calendar.searchClientName" defaultMessage="Client name:" /> {item.clientName}</p>
                                    </div>
                                }
                            </>
                        ))}
                    </div>}
                </div>
            </div>
            {showYearlyProduction ?
                <div className={'calendar-wrapper'}>
                    {selectedMonths?.map((month) => {
                        return <div className={'calendar-holder'} onClick={() => selectCalendarView(month.value)}>
                            <FullCalendar
                                plugins={[daygridPlugin]}
                                eventContent={renderEventContent}
                                // eventDrop={saveChangedDate}
                                events={calendarEvents}
                                initialDate={month.value}
                                eventDragStart={(eventInfo: any) => setSelectedProduct(eventInfo.event)}
                                headerToolbar={{
                                    right: "prev,next",
                                    center: "title",
                                    left: "dayGridMonth"
                                }}
                            />
                        </div>
                    })}
                </div> :
                <FullCalendar
                    plugins={[daygridPlugin, interactionPlugin, timeGridPlugin]}
                    eventContent={renderEventContent}
                    // eventDrop={saveChangedDate}
                    events={calendarEvents}
                    initialDate={calendarDateView}
                    eventDragStart={(eventInfo: any) => setSelectedProduct(eventInfo.event)}
                    headerToolbar={{
                        right: "prev,next",
                        center: "title",
                        left: "dayGridMonth,timeGridWeek,timeGridDay"
                    }}
                />
            }
            {selectedAgreement?.id && <div className={'agreementExtraInfoModal-wrapper'}>
                <div className={'agreementExtraInfoModal'}>
                    <div className={'x-sign-container'}>
                        <HotkeyButton
                            keyCode="Escape"
                            modifiers={[]}
                            isActive={false}
                            onStateChange={(state) => {
                                if (state) {
                                    closeAgreementInfoModal()
                                }
                            }}
                        >
                            <img className={'x-sign'} src={DifferentColoredPlus} alt="" onClick={() => {
                                closeAgreementInfoModal()
                            }}/>
                        </HotkeyButton>
                    </div>
                    <div className={'agreementContent'}>
                        {loading ? <SimpleLoader/> :
                            <>
                                <div className={'titleContainer'}>
                                    <p>{props?.projectDetails?.measure?.clientNameAndLastName}({props?.projectDetails?.agreement?.totalDebtLeft}€)</p>
                                    <p>{props?.projectDetails?.agreement?.projectName}</p>
                                </div>
                                <div className={''}>
                                    <DataTransferComponent clientId={props?.client?.client?.id} measureNeeded
                                                           agreementNeeded noProjectDetails noContactDetails/>
                                </div>
                                <div className={'w-100 d-flex align-items-end p-2'}>
                                    <Input
                                        name="date"
                                        value={startDate ? startDate : ''}
                                        type="date"
                                        onChange={(name, value) => {
                                            setStartDate(value)
                                        }}
                                        inputWrapperClass={`simple-date-input w-100 m-0 p-0 pe-0 mb-0 heightFitContent ${startDate ? " " : 'does-not-have-data'}`}>
                                        <FormattedMessage id="agreement.calendar.dateStart" defaultMessage="Start date"/>
                                    </Input>
                                </div>
                                <div className={'w-100 d-flex align-items-end p-2'}>
                                    <Input
                                        name="date"
                                        value={endDate ? endDate : ''}
                                        type="date"
                                        onChange={(name, value) => {
                                            setEndDate(value)
                                        }}
                                        inputWrapperClass={`simple-date-input w-100 m-0 p-0 pe-0 mb-0 heightFitContent ${endDate ? " " : 'does-not-have-data'}`}>
                                        <FormattedMessage id="agreement.calendar.dateEnd" defaultMessage="End date"/>
                                    </Input>
                                </div>
                                <div className={''}>
                                    <Button
                                        isLoading={props?.buttonLoader}
                                        isDisabled={props?.buttonLoader}
                                        submit={true}
                                        className="m-auto w-100"
                                        onClick={saveAgreementDates}
                                        buttonType={EButtonType.GreyButton}>
                                            <FormattedMessage id="common.action.save" defaultMessage="Save"/>
                                    </Button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>}
            {showTaskModal && <div className={'taskCreationModal-wrapper'}>
                <TaskForm getUpdatedData={props.agreementActions.getAgreementsForCalendar} task={selectedTask}
                          setSelectedTask={setSelectedTask} setShowTaskModal={setShowTaskModal}/>
            </div>}

            {/* Offer Installation Details Modal */}
            {selectedOffer && (
                <div className="offer-modal-wrapper">
                    <div className="offer-modal">
                        {/* Header */}
                        <div className="offer-modal__header">
                            <HotkeyButton
                                keyCode="Escape"
                                modifiers={[]}
                                isActive={false}
                                onStateChange={(state) => {
                                    if (state) {
                                        closeOfferModal()
                                    }
                                }}
                            >
                                <button
                                    className="offer-modal__close-btn"
                                    onClick={() => closeOfferModal()}
                                >
                                    <img src={DifferentColoredPlus} alt="close" />
                                </button>
                            </HotkeyButton>
                            <h3><FormattedMessage id="agreement.calendar.installationDetails" defaultMessage="Installation details" /></h3>
                        </div>

                        {/* Content */}
                        <div className="offer-modal__content">
                            {/* Info Card with Grid */}
                            <div className="offer-modal__info-card">
                                <div className="offer-modal__info-grid">
                                    <div className="offer-modal__info-item">
                                        <span className="offer-modal__label"><FormattedMessage id="offer.list.column.client" defaultMessage="Client" /></span>
                                        <p className="offer-modal__value">{selectedOffer?.clientName}</p>
                                    </div>
                                    <div className="offer-modal__info-item">
                                        <span className="offer-modal__label">ID</span>
                                        <p className="offer-modal__value">#{selectedOffer?.clientId}</p>
                                    </div>
                                    <div className="offer-modal__info-item">
                                        <span className="offer-modal__label"><FormattedMessage id="offer.list.column.project" defaultMessage="Project" /></span>
                                        <p className="offer-modal__value">{selectedOffer?.projectName || '-'}</p>
                                    </div>
                                    <div className="offer-modal__info-item">
                                        <span className="offer-modal__label"><FormattedMessage id="offer.list.column.status" defaultMessage="Status" /></span>
                                        <p className="offer-modal__value">{selectedOffer?.offerStatus || '-'}</p>
                                    </div>
                                    <div className="offer-modal__info-item">
                                        <span className="offer-modal__label"><FormattedMessage id="agreement.calendar.pocLabel" defaultMessage="Point of contact" /></span>
                                        <p className="offer-modal__value">{selectedOffer?.pointOfContactName || '-'}</p>
                                    </div>
                                    <div className="offer-modal__info-item">
                                        <span className="offer-modal__label"><FormattedMessage id="agreement.calendar.installationDate" defaultMessage="Installation date" /></span>
                                        <div className="offer-modal__date-picker">
                                            {newInstallationDate && (
                                                <img
                                                    src={DifferentColoredPlus}
                                                    onClick={() => setNewInstallationDate(null)}
                                                    className="date-clear-btn"
                                                    alt="clear"
                                                />
                                            )}
                                            <DatePicker
                                                selected={newInstallationDate}
                                                onChange={(date: Date) => setNewInstallationDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText={fm('offer.form.selectDate', 'Pick date')}
                                                minDate={new Date()}
                                                className="date-picker-input"
                                                popperPlacement="bottom-start"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Products List */}
                            {selectedOffer?.products?.length > 0 && (
                                <div className="offer-modal__products">
                                    <span className="offer-modal__label">
                                        <FormattedMessage id="agreement.calendar.products" defaultMessage="Products ({count})" values={{ count: selectedOffer.products.length }} />
                                    </span>
                                    <div className="offer-modal__products-list">
                                        {selectedOffer.products.map((product: any, idx: number) => (
                                            <div key={idx} className="offer-modal__product-item">
                                                <span className="offer-modal__product-name">
                                                    {product?.articleName || product?.designation}
                                                </span>
                                                <span className="offer-modal__product-units">
                                                    {product?.unit} <FormattedMessage id="agreement.calendar.units" defaultMessage="units" />
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Comment Section */}
                            <div className="offer-modal__comment-section">
                                <span className="offer-modal__label">
                                    <FormattedMessage id="offer.form.commentLabel" defaultMessage="Comment:" /> <span className="text-danger">*</span>
                                </span>
                                <textarea
                                    className="offer-modal__textarea"
                                    value={installationDateComment}
                                    onChange={(e) => setInstallationDateComment(e.target.value)}
                                    placeholder={fm('agreement.calendar.commentPlaceholder', 'Enter the reason for changing the date...')}
                                />
                            </div>

                            {/* History Section */}
                            {installationDateHistory?.length > 0 && (
                                <div className="offer-modal__history">
                                    <button
                                        className="offer-modal__history-toggle"
                                        onClick={() => setShowInstallationHistory(!showInstallationHistory)}
                                    >
                                        <span className={`offer-modal__history-arrow ${showInstallationHistory ? 'offer-modal__history-arrow--open' : ''}`}>
                                            ▶
                                        </span>
                                        <span className="offer-modal__history-text">
                                            <FormattedMessage id="agreement.calendar.historyTitle" defaultMessage="Change history ({count})" values={{ count: installationDateHistory.length }} />
                                        </span>
                                    </button>
                                    {showInstallationHistory && (
                                        <div className="offer-modal__history-list">
                                            {installationDateHistory.map((item: any, index: number) => (
                                                <div key={index} className="offer-modal__history-item">
                                                    <div className="offer-modal__history-header">
                                                        <span className="offer-modal__history-date">{item.installationDate}</span>
                                                        <span className="offer-modal__history-time">{item.changedAt}</span>
                                                    </div>
                                                    <div className="offer-modal__history-user"><FormattedMessage id="agreement.calendar.historyBy" defaultMessage="By:" /> {item.changedByUser}</div>
                                                    {item.comment && (
                                                        <div className="offer-modal__history-comment">{item.comment}</div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="offer-modal__footer">
                            <button
                                className="offer-modal__btn offer-modal__btn--secondary"
                                onClick={navigateToOffer}
                            >
                                <FormattedMessage id="agreement.calendar.viewOffer" defaultMessage="View offer" />
                            </button>
                            <button
                                className="offer-modal__btn offer-modal__btn--primary"
                                onClick={saveInstallationDate}
                                disabled={savingDate}
                            >
                                {savingDate
                                    ? <FormattedMessage id="agreement.calendar.savingChanges" defaultMessage="Saving..." />
                                    : <FormattedMessage id="agreement.calendar.saveChanges" defaultMessage="Save changes" />}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}


function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        client: state.client,
        agreements: state?.agreements,
        offers: state?.offers
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
        clientActions: bindActionCreators(clientActions as any, dispatch),
        agreementActions: bindActionCreators(agreementActions as any, dispatch),
        offerActions: bindActionCreators(offerActions as any, dispatch),
    }
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(AgreementCalendar as any)));